export var cilStickyNote = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M24,24V496H318.627L496,318.627V24ZM56,56H464V264H264V464H56ZM305.373,464H296V296H464v9.373Z' class='ci-primary'/>"];
